import React, { useState } from 'react';
import { Form, Button, Row, Col, FormCheck, Dropdown } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'; // Ensure Bootstrap CSS is included
import { Link } from "react-router-dom";

// Define inline styles
const containerStyle = {
    maxWidth: '800px',
    marginTop:"15px",
    padding: '20px',
    border: '1px solid #ced4da',
    borderRadius: '0.25rem',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
    backgroundColor: '#ffffff',
};

const legendStyle = {
    fontSize: '1.5rem',
    marginBottom: '20px',
    color: '#343a40',
};

const formLabelStyle = {
    fontSize: '1rem',
    fontWeight: '500',
    color: '#495057',
};

const requiredStyle = {
    color: '#dc3545',
};

const selectStyle = {
    borderColor: '#ced4da',
    borderRadius: '0.25rem',
};



const dropdownToggleStyle = {
    width: '100%',
};

const ProductComparisonReport = () => {
    const [currentStartDate, setCurrentStartDate] = useState("2024-08-01");
    const [currentEndDate, setCurrentEndDate] = useState("2024-08-31");
    const [previousStartDate, setPreviousStartDate] = useState("2024-07-01");
    const [previousEndDate, setPreviousEndDate] = useState("2024-07-31");
    const [includeInactive, setIncludeInactive] = useState(false);
    const [selectedProcedures, setSelectedProcedures] = useState([]);
    const [byAttributes, setByAttributes] = useState(false);
    const [excludeZeroAttributes, setExcludeZeroAttributes] = useState(false);
    const [financeCharges, setFinanceCharges] = useState(false);
    const [generalInvoices, setGeneralInvoices] = useState(false);
    const [additionalLines, setAdditionalLines] = useState(false);
    const [components, setComponents] = useState(false);
    const [format, setFormat] = useState("");

    const procedures = [
        { id: 1, name: "TEMPORARY CROWN" },
        { id: 2, name: "SCREW RETAINED TEMPORARY PONTIC" },
        { id: 3, name: "SOFT TISSUE (2 UNITS)" },
        { id: 4, name: "TEMPORARY DENTURE" }
    ];

    const handleProcedureSelect = (id) => {
        setSelectedProcedures(prevState =>
            prevState.includes(id)
                ? prevState.filter(procedureId => procedureId !== id)
                : [...prevState, id]
        );
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Handle the form submission logic here
    };

    return (
        <div style={containerStyle}>
            <Form onSubmit={handleSubmit} className="report_parameters no_print large_label" id="report_product_comparison">
                <input type="hidden" name="column" value="" />
                <input type="hidden" name="direction" value="" />
                <fieldset>
                    <legend style={legendStyle}>Parameters</legend>

                    <Form.Group as={Row} controlId="product-comparison-current-start-date">
                        <Form.Label column sm={4} style={formLabelStyle}>
                            Current Start Date <span style={requiredStyle}>*</span>
                        </Form.Label>
                        <Col sm={8}>
                            <Form.Control
                                type="date"
                                name="current_start_date"
                                required
                                value={currentStartDate}
                                onChange={(e) => setCurrentStartDate(e.target.value)}
                            />
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="product-comparison-current-end-date">
                        <Form.Label column sm={4} style={formLabelStyle}>
                            Current End Date <span style={requiredStyle}>*</span>
                        </Form.Label>
                        <Col sm={8}>
                            <Form.Control
                                type="date"
                                name="current_end_date"
                                required
                                value={currentEndDate}
                                onChange={(e) => setCurrentEndDate(e.target.value)}
                            />
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="product-comparison-previous-start-date">
                        <Form.Label column sm={4} style={formLabelStyle}>
                            Previous Start Date <span style={requiredStyle}>*</span>
                        </Form.Label>
                        <Col sm={8}>
                            <Form.Control
                                type="date"
                                name="previous_start_date"
                                required
                                value={previousStartDate}
                                onChange={(e) => setPreviousStartDate(e.target.value)}
                            />
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="product-comparison-previous-end-date">
                        <Form.Label column sm={4} style={formLabelStyle}>
                            Previous End Date <span style={requiredStyle}>*</span>
                        </Form.Label>
                        <Col sm={8}>
                            <Form.Control
                                type="date"
                                name="previous_end_date"
                                required
                                value={previousEndDate}
                                onChange={(e) => setPreviousEndDate(e.target.value)}
                            />
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="report_product_comparison_include_inactive">
                        <Col sm={4}>
                            <FormCheck
                                type="checkbox"
                                name="include_inactive"
                                value="1"
                                checked={includeInactive}
                                onChange={(e) => setIncludeInactive(e.target.checked)}
                                label="Inactive Selectable?"
                            />
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="product_comparison_procedure">
                        <Form.Label column sm={4} style={formLabelStyle}>Procedures</Form.Label>
                        <Col sm={8}>
                            <Dropdown>
                                <Dropdown.Toggle variant="secondary" id="dropdown-basic" style={dropdownToggleStyle}>
                                    {selectedProcedures.length > 0 ? "Selected Procedures" : "Select Procedures"}
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    {procedures.map(procedure => (
                                        <Dropdown.Item
                                            key={procedure.id}
                                            onClick={() => handleProcedureSelect(procedure.id)}
                                        >
                                            <FormCheck
                                                type="checkbox"
                                                checked={selectedProcedures.includes(procedure.id)}
                                                label={procedure.name}
                                                onChange={() => handleProcedureSelect(procedure.id)}
                                            />
                                        </Dropdown.Item>
                                    ))}
                                </Dropdown.Menu>
                            </Dropdown>
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="report_product_comparison_by_attributes">
                        <Col sm={4}>
                            <FormCheck
                                type="checkbox"
                                name="by_attributes"
                                value="1"
                                checked={byAttributes}
                                onChange={(e) => setByAttributes(e.target.checked)}
                                label="Base report on Attributes"
                            />
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="report_product_comparison_exclude_zero_attributes" style={{ display: 'none' }}>
                        <Col sm={4}>
                            <FormCheck
                                type="checkbox"
                                name="exclude_zero_attributes"
                                value="1"
                                checked={excludeZeroAttributes}
                                onChange={(e) => setExcludeZeroAttributes(e.target.checked)}
                                label="Exclude Attributes when units and price are zero"
                            />
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="report_product_comparison_finance_charges">
                        <Col sm={4}>
                            <FormCheck
                                type="checkbox"
                                name="finance_charges"
                                value="1"
                                checked={financeCharges}
                                onChange={(e) => setFinanceCharges(e.target.checked)}
                                label="Exclude Finance Charges?"
                            />
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="report_product_comparison_general_invoices">
                        <Col sm={4}>
                            <FormCheck
                                type="checkbox"
                                name="general_invoices"
                                value="1"
                                checked={generalInvoices}
                                onChange={(e) => setGeneralInvoices(e.target.checked)}
                                label="Exclude General Invoices?"
                            />
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="report_product_comparison_additional_lines">
                        <Col sm={4}>
                            <FormCheck
                                type="checkbox"
                                name="additional_lines"
                                value="1"
                                checked={additionalLines}
                                onChange={(e) => setAdditionalLines(e.target.checked)}
                                label="Exclude Additional Lines?"
                            />
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="report_product_comparison_components">
                        <Col sm={4}>
                            <FormCheck
                                type="checkbox"
                                name="components"
                                value="1"
                                checked={components}
                                onChange={(e) => setComponents(e.target.checked)}
                                label="Exclude Components?"
                            />
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="product_comparison_format">
                        <Form.Label column sm={4} style={formLabelStyle}>
                            Format <span style={requiredStyle}>*</span>
                        </Form.Label>
                        <Col sm={8}>
                            <Form.Control
                                as="select"
                                name="format"
                                value={format}
                                onChange={(e) => setFormat(e.target.value)}
                                style={selectStyle}
                            >
                                <option value="">On Screen</option>
                                <option value="csv">CSV (Excel)</option>
                            </Form.Control>
                        </Col>
                    </Form.Group>

                     <Form.Group >
                                     <Col sm={{ span: 8, offset: 4 }}>
                                       <Link to="/Addproductcomparison">
                                         <Button
                                           id="pay-per-task-submit"
                                           type="button"
                                           variant="primary"
                                           className="w-100 mt-2"
                                           style={{
                                             backgroundColor: '#004aad',
                                             borderColor: '#004aad',
                                             marginTop: '10px',
                                           }}
                                         >
                                           Run
                                         </Button>
                                       </Link>
                                     </Col>
                                    </Form.Group>
                </fieldset>
            </Form>
                      
        </div>
    );
};

export default ProductComparisonReport;
